module.exports = __webpack_public_path__ + "assets/img/page4-side-nav-neutral-8beb235f.png";